import { useEffect } from 'react';
import { Badge } from 'react-bootstrap';
import { useCreateCommonOnlinePayment } from '../apiEndpoints/commonApiEndpoints';

interface OnlinePayProps {
  userId: number | string | null | undefined;
  userType: 'Exhibitor' | 'Visitor' | 'B2B';
  invoiceId: number | string | undefined;
  paymentType?: 'online'; // default online
  paymentMethod?: string; // default sslc
  isDisabled?: boolean; // if user already paid
  isPaid?: 'Paid'; // if user already paid
}

const CommonOnlinePayment = ({
  userId,
  userType,
  invoiceId,
  paymentType = 'online',
  paymentMethod = 'sslc',
  isDisabled = false,
  isPaid,
}: OnlinePayProps) => {
  const {
    mutate,
    isPending,
    data: onlinePaymentData,
  } = useCreateCommonOnlinePayment();

  const alreadyPaid = isPaid === 'Paid';
  const cannotPay = isDisabled || alreadyPaid;

  // Handle redirect URL
  useEffect(() => {
    if (onlinePaymentData?.data?.redirect_url) {
      window.open(
        onlinePaymentData.data.redirect_url,
        '_blank',
        'noopener,noreferrer',
      );
    }
  }, [onlinePaymentData?.data]);

  const handlePayment = () => {
    if (cannotPay) return;

    const formData = new FormData();
    formData.append('user_id', String(userId));
    formData.append('user_type', userType);
    formData.append('invoice_id', String(invoiceId));
    formData.append('payment_type', paymentType);
    formData.append('payment_method', paymentMethod);

    mutate(formData);
  };

  return (
    <Badge
      bg={cannotPay ? 'secondary' : 'primary'}
      text={'light'}
      style={{
        fontSize: '12px',
        cursor: cannotPay ? 'not-allowed' : 'pointer',
        textDecoration: alreadyPaid ? 'line-through' : 'none',
      }}
      onClick={!cannotPay ? handlePayment : undefined}
    >
      {isPending ? 'Processing...' : 'Pay Now'}
    </Badge>
  );
};

export default CommonOnlinePayment;
